import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function() {
  const slidersWithNavs = document.querySelectorAll('.slider-with-nav');
  const sliderNavs = document.querySelectorAll('.slider-nav');
  const slidersDefault = document.querySelectorAll('.slider-default');
  const slidersArt = document.querySelectorAll('.art-slider');
  const homepageHero = document.querySelectorAll('.hero-slider.splide');

  slidersWithNavs.forEach(slider => {
    const splideSlider = new Splide(slider, {
      type: 'loop',
      perMove: 1,
      perPage: 1,
      rewind: true,
      pagination: false,
      arrows: false,
      breakpoints: {
        600: {
          arrows: true,
        },
      },
    });

    splideSlider.mount();

    sliderNavs.forEach(sliderNav => {
      const splideSliderNav = new Splide(sliderNav, {
        gap: 5,
        perMove: 1,
        perPage: 4,
        rewind: true,
        pagination: true,
        arrows: true,
        isNavigation: true,
        rewindByDrag: true,
      });

      splideSliderNav.mount();

      splideSlider.sync(splideSliderNav);
    });
  });

  slidersDefault.forEach(slider => {
    const splideSlider = new Splide(slider, {
      type: 'loop',
      gap: 10,
      rewind: true,
      perPage: 4,
      perMove: 1,
      pagination: true,
      arrows: true,
      breakpoints: {
        1024: {
          perPage: 3,
        },
        900: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        },
      },
    });

    splideSlider.mount();
  });

  slidersArt.forEach(slider => {
    const artSlider = new Splide(slider, {
      rewind: true,
      perPage: 2,
      perMove: 1,
      pagination: true,
      arrows: true,
      breakpoints: {
        900: {
          perPage: 1,
        },
      },
    });

    artSlider.mount();
  });

  homepageHero.forEach(slider => {
    const heroSlider = new Splide(slider, {
      type: 'loop',
      height: '100vh',
      fixedHeight: '100vh',
      perPage: 1,
      perMove: 1,
      pagination: true,
      arrows: true,
    });

    heroSlider.mount();
  });
});
